<template>
  <div>
    <div class="search">
      <div class="left">
        <el-input
          v-model.trim="search.keyword"
          placeholder="请输入编号/聚合预算/所属/代理商"
          clearable
          class="input"
        />
        <el-select
          v-model="search.sale_type"
          class="ml"
          placeholder="请选择预算类型"
          clearable
        >
          <el-option
            v-for="(v, i) in budgetTypeSelection"
            :key="i"
            :label="v.name"
            :value="v.value"
          />
        </el-select>
        <el-button
          type="primary"
          plain
          class="ml"
          @click="handleSearch"
        >
          查询
        </el-button>
      </div>
      <div class="right" v-if="showBtnList">
        <el-button
          type="primary"
          plain
          @click="handleDownload"
        >
          下载
        </el-button>

        <el-button
          type="primary"
          plain
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div>
    </div>

    <div class="data">
      <el-table
        :data="list"
        border
      >
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            <template v-if="c.prop === 'status'">
              <el-button
                v-if="scope.row.status === '0'"
                plain
              >
                失效
              </el-button>
              <el-button
                v-else
                type="success"
                plain
              >
                {{ scope.row.status | filterStatus }}
              </el-button>
            </template>
            <template v-else-if="c.prop === 'sale_type'">
              <span v-if="scope.row.sale_type === '0'">-</span>
              <span v-else>{{ scope.row.sale_type | filterBudgetType }}</span>
            </template>
            <template v-else-if="c.prop === 'belong_name'">
              <span v-if="scope.row.belong_name">{{ scope.row.belong_name }}</span>
              <span v-else>-</span>
            </template>
            <template v-else>
              {{ scope.row[c.prop] }}
            </template>

            <template v-if="c.prop === 'opt'">
              <el-button
                type="text"
                @click="handleCtrlEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlCancel(scope.row)"
              >
                {{ scope.row.status === '0' ? '置为有效' : '置为失效' }}
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlLogOpen(scope.row)"
              >
                日志
              </el-button>
            </template>
          </div>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div>
    </div>

    <!-- 新建 & 编辑 -->
    <el-dialog
      :visible.sync="detailVisible"
      :title="form.id ? '修改' : '添加'"
      width="600px"
      class="dialog"
    >
      <el-form label-width="120px">
        <el-form-item label="聚合预算">
          <el-input
            v-model="form.budget_name"
            placeholder="输入聚合预算名称"
            class="input"
          />
        </el-form-item>
        <!-- <el-form-item label="销售名称">
          <el-input
            v-model="form.sale_name"
            placeholder="输入并选择销售"
            class="input"
          />
        </el-form-item> -->
        <el-form-item label="预算类型">
          <el-select
            v-model="form.sale_type"
            placeholder="请选择预算类型"
            clearable
            style="width: 400px;"
          >
            <el-option
              v-for="(item, i) in budgetTypeOptions"
              :key="i"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属"
          prop="owner"
        >
          <el-select
            v-model="form.owner"
            filterable
            multiple
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="输入并选择所属"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 91%"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="代理商">
          <el-input
            v-model="form.agent_name"
            placeholder="输入代理商"
            class="input"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!--日志-->
    <el-dialog
      title="日志"
      :visible.sync="logVisible"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
const req = new Request();
let self;
export default {
  name: 'aggregation-bind',

  filters: {
    filterStatus(v) {
      return self.optionStatusList.filter((f) => f.value === Number(v))[0].name;
    },
    filterBudgetType(v) {
      return self.budgetTypeOptions.filter((f) => f.value === Number(v))[0]
        .name;
    },
  },
  data() {
    return {
      optionStatusList: [
        { name: '有效', value: 1 },
        { name: '失效', value: 0 },
      ],

      search: {
        keyword: '',
        sale_type: '',
      },

      column: [
        { label: '编号', prop: 'id' },
        { label: '聚合预算', prop: 'budget_name' },
        { label: '预算类型', prop: 'sale_type' },
        { label: '所属', prop: 'belong_name' },
        { label: '代理商', prop: 'agent_name' },
        { label: '状态', prop: 'status' },
        { label: '操作', prop: 'opt' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,

      detailVisible: false,
      form: {
        id: '',
        budget_name: '',
        owner_name: '',
        owner: '',
        sale_type: '',
        agent_name: '',
      },

      logVisible: false,
      logId: '',
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,

      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
      budgetTypeOptions: [
        { value: 1, name: '直投' },
        { value: 2, name: '渠道' },
      ],
      budgetTypeSelection: [
        { value: 1, name: '直投' },
        { value: 2, name: '渠道' },
        { value: 0, name: '无' },
      ],
      userInfo: {},
    };
  },
  computed: {
    showBtnList(){
      let role_ids = this.userInfo.role_ids || [];
      return !(role_ids.includes('2') || role_ids.includes("3"))
    },
  },
  mounted() {
    self = this;
    this.init();
    this.getUserInfo();
  },

  methods: {
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    // 输入并选择销售名称下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            is_budget: 1,
            names: key,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.data || [];
      } catch (err) {
        this.$message.error(`获取销售失败：${err.message || '未知错误'}`);
      }
    },

    init() {
      this.getList();
    },

    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },

    async handleDownload() {
      try {
        const res = await req.send(req.Apis.customer.budgetBind.download, {});
        if (res.code === 200) {
          const url = res.data.url;
          if(url) {
            const a = document.createElement('a')
            a.href = url
            a.download = '聚合预算列表.csv'
            a.click()
          }
          
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.budgetBind.list, {
          keyword: this.search.keyword,
          sale_type: this.search.sale_type,
          page: this.page,
          page_size: this.pageSize,
        });
        this.list = data.list || [];
        this.total = Number(data.total);
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },

    // 操作按钮: 编辑
    handleCtrlEdit(row) {
      this.form = {
        id: parseInt(row.id),
        budget_name: row.budget_name,
        owner_name: row.owner_name || '',
        owner: row.owner ? row.owner.split(",") : [],
        sale_type: parseInt(row.sale_type) || '',
        agent_name: row.agent_name,
      };
      // 清空销售选项
      this.editProdSalorDlg.options = [];
      // 加载销售选项
      if (row.owner_name) {
        this._searchSalors(row.owner_name);
      }
      this.detailVisible = true;
    },

    // 操作按钮: 失效&有效
    handleCtrlCancel(row) {
      this.$confirm('确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await req.send(req.Apis.customer.budgetBind.review, { id: row.id });
          this.$message.success('操作成功');
          this.getList();
        } catch (err) {}
      });
    },

    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budgetBind.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 2,
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },

    // dialog: open
    handleDialogOpen() {
      this.detailVisible = true;
      this.form = {
        id: '',
        budget_name: '',
        owner_name: '',
        owner: '',
        sale_type: '',
        agent_name: '',
      };
    },

    // dialog: 添加&编辑
    async handleDialogConfirm() {
      let params = {
        budget_name: this.form.budget_name,
        owner_name: this.form.owner_name,
        owner: this.form.owner.join(','),
        sale_type: this.form.sale_type,
        agent_name: this.form.agent_name,
      };
      let api = req.Apis.customer.budgetBind.add;

      if (!this.form.budget_name) {
        this.$message.error('请输入聚合预算名称');
        return;
      }

      // if (!this.form.agent_name) {
      //   this.$message.error('请输入代理商');
      //   return;
      // }

      // 编辑
      if (this.form.id) {
        params['id'] = this.form.id;
        api = req.Apis.customer.budgetBind.update;
      }

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
        // 清空表单
        this.form = {
          id: '',
          budget_name: '',
          owner_name: '',
          owner: '',
          sale_type: '',
          agent_name: '',
        };
        this.detailVisible = false;
      } catch (err) {
      }
    },
  },
};
</script>

<style lang="less">
.search {
  display: flex;
  justify-content: space-between;
  & .ml {
    margin-left: 15px;
  }
  & .left {
    & .input {
      width: 300px;
    }
  }
  & .right {
  }
}

.data {
  margin-top: 20px;
  & .page {
    margin-top: 20px;
    text-align: right;
  }
}

.dialog {
  & .input {
    width: 400px;
  }
}
</style>
